import { SWRConfiguration } from 'swr';

import { useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';
import { AppModules } from '~/services/Permissions';

import { useModulesConfig } from '../company';

import { CustomFieldValues } from './types';

export const getCustomEmployeePositionFields = (
  id: number,
): Promise<CustomFieldValues> => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE_POS/${id}`).then((r) =>
    r.json(),
  );
};

export const useCustomPositionFields = (
  employeeId: number,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { isModuleEnabled } = useModulesConfig();
  const isCustomDataEnabled = isModuleEnabled(AppModules.CUSTOM_DATA);

  const { data, isLoading, error } = useSWR<CustomFieldValues>(
    !isDisabled && isCustomDataEnabled
      ? ['getCustomEmployeePositionFields']
      : null,
    () => getCustomEmployeePositionFields(employeeId),
    swrConfig,
  );

  return {
    data,
    isLoading,
    error,
  };
};
